import angular from 'angular';
import moment from 'moment';

// eslint-disable-next-line angular/window-service
const { host, protocol } = window.location;
const PREFIX = `${protocol}//${host.substr(0, host.indexOf('-') + 1)}`;
const DOMAIN = `${host.substr(host.indexOf('.') + 1)}`;

const ACCOUNTS_APP = `${PREFIX}accounts.${DOMAIN}`;
const VERIFY_APP = `${PREFIX}app.${DOMAIN}`;
const PDF_JS = 'https://pdfviewer.employeebgc.com/web/viewer.html';
const CDN_LINK = 'https://cdn.employeebgc.com';
const CLEARBIT_LINK = 'https://autocomplete.clearbit.com';
const API_SERVER = VERIFY_APP;

const constants = angular
  .module('verifyApp.constants', [])
  .constant('moment', moment)
  .constant('urls', {
    API_SERVER,
    ACCOUNTS_APP,
    VERIFY_APP,
    PDF_JS,
    CDN_LINK,
    CLEARBIT_LINK,
    LOGIN: `${ACCOUNTS_APP}/signin?client_id=mainapp`,
  })
  .constant('APPS', {})
  .constant('GROUPS', {
    CONSULTANT: 2,
  })
  .constant('VENDOR_ID', 2)
  .constant('CASE_CHECK_STATUS', [
    'In-Process',
    'Pending',
    'Positive',
    'Negative',
    'Discrepant',
    'Not Verifiable',
    'Cancelled',
  ])
  .constant('SUB_CASE_STATES', [
    'Pending',
    'Submitted',
    'Hold',
    'Refused',
    'Closed',
  ])
  .constant('ENABLE_TA_DATE_CLIENT_IDS', [
    6079,
  ])
  .constant('INTERNAL_VENDOR_CLIENT_IDS', [
    2,
  ])
  .constant('CASE_JOINING_STATUSES', [
    { value: 'Yet to Join', name: 'Yet to Join' },
    { value: 'Joined', name: 'Joined' },
  ])
  .constant('CASE_BUCKETS', {
    CUSTOMER: [
      'PENDING', 'PARTIALLY_PENDING', 'IN_PROGRESS',
      'FINAL_REPORT_SUBMITTED', 'CLOSED', 'ALL',
    ],
    VENDOR: [
      'NEW', 'IN_PROGRESS', 'PARTIALLY_PENDING',
      'PENDING_FROM_CLIENT', 'FINAL_REPORT_SUBMITTED',
      'CLOSED', 'ALL',
    ],
  });

export default constants.name;



// WEBPACK FOOTER //
// ./client/app/app.constant.js